/*
  sb-hero.js — hero-video gedrag (progressive enhancement; werkt ook zonder JS).
  - Poster-beeld is de LCP en blijft staan tot de video echt speelt (geen flash/CLS).
  - Respecteert prefers-reduced-motion: video pauzeert, poster blijft (EAA/a11y).
  - Autoplay kan door de browser geblokkeerd worden → poster blijft gewoon zichtbaar.
*/
(function () {
  function initHero(hero) {
    var video = hero.querySelector('.sb-hero__video');
    if (!video) return;

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection;
    var saveData = conn && (conn.saveData || /(2g|slow-2g)$/.test(conn.effectiveType || ''));

    if (reduce || saveData) {
      video.removeAttribute('autoplay');
      try { video.pause(); } catch (e) {}
      return; // poster (<img>) blijft de eindstaat — bespaart data/CPU
    }

    var reveal = function () { hero.classList.add('sb-hero--video-ready'); };
    video.addEventListener('playing', reveal, { once: true });

    // De poster-<img> is de LCP; start de video pas ná de kritieke render zodat 'ie LCP/TBT niet in de weg zit.
    var start = function () {
      if (video.readyState >= 3) reveal();
      var played = video.play && video.play();
      if (played && typeof played.catch === 'function') {
        played.catch(function () { /* autoplay geblokkeerd → poster blijft */ });
      }
    };
    var defer = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2500 });
      else setTimeout(start, 800);
    };
    if (document.readyState === 'complete') defer();
    else window.addEventListener('load', defer, { once: true });
  }

  function init() {
    document.querySelectorAll('.sb-hero').forEach(initHero);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
